import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { isEmployer, isAgency, homeFor } from "@/lib/roles";

export default function ProtectedRoute({ children, employerOnly = false, agencyOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen wo-bg flex items-center justify-center">
        <div className="w-10 h-10 rounded-full border-2 border-teal-400/30 border-t-teal-400 animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (employerOnly && !isEmployer(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  if (agencyOnly && !isAgency(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return children;
}
